'use strict';

export default class NavigatorUtils {
    static isIE() {
        return !!navigator.userAgent.match(/Trident.*rv\:11\./);
    }

    static isMobile() {
    	if ((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
            return true;
        }

        return false;
    }

    static isAndroid() {
    	return navigator.userAgent.toLowerCase().indexOf("android") > -1
    }

    static isIOS() {
    	return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    }
}



// WEBPACK FOOTER //
// ./src/javascript-classes/utils/navigator.js